import { useEffect, useState } from 'react';

/**
 * A slow clock for relative timestamps. One interval per consumer is cheaper
 * than a per-row timer, and 5 s is under the resolution "12s ago" implies.
 */
export function useNow(intervalMs = 5_000): number {
  const [now, setNow] = useState(() => Date.now());

  useEffect(() => {
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);

  return now;
}
